module.exports = __webpack_public_path__ + "assets/img/ztrs.ae2d4c4d.png";